import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import escalatorImage from "../../assets/images/parent-zone/escalator-safety.png";
import { CloseButton } from "../components/CloseButton";

export interface EscalatorSafetyScreenProps
{
}

interface EscalatorSafetyScreenState 
{
    loading: boolean;
}

export class EscalatorSafetyScreen extends Component<EscalatorSafetyScreenProps, EscalatorSafetyScreenState>
{
    constructor(props: EscalatorSafetyScreenProps)
    {
        super(props);

        this.state = {
            loading: true
        };
    }

    public componentDidMount(): void
    {
    }

    private onCloseIFrameClicked(): void 
    {
        App.I.changeScreen(AppScreen.ParentZone);
    }

    public render(): JSX.Element
    {
        return (
            <>
                <div className="screen screen-esclator-safety">
                    <div className="header">
                        <CloseButton onClicked={this.onCloseIFrameClicked.bind(this)} />

                        <div className="container text-center">
                            <h1 className="text-uppercase title">
                                Safety Tips
                            </h1>
                        </div>
                    </div>

                    <div className="image" title="Person on escalator">
                    </div>

                    <div className="text">
                        <div className="container text-center">
                            <p className="tip mt-3">
                                Take care when on escalators
                            </p>
                            <p className="tip">
                                Use lifts if travelling with heavy bags or pushchairs
                            </p>
                            <p className="tip">
                                Do not allow children to sit on trolleys or baggage carousel
                            </p>
                            <p className="tip no-border">
                                Stay hydrated - our water filling stations are located near the toilets
                            </p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}